module.exports = __webpack_public_path__ + "img/center03.7b848f3c.webp";